module.exports = __webpack_public_path__ + "static/media/partnerDetailBanner.7a09b261.png";